function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import __ from 'ramda/src/__';
import { stateGo } from 'redux-ui-router';
import { RouteParams, RouteCurrentStateSelector } from 'invision-core/src/components/router/router.selectors';
import { LastRouteSelector } from 'invision-core/src/components/session/session.selectors';
import { fetchCodeTypes } from 'invision-core/src/components/metadata/codes/codes.actions';
import { MetadataCodeLoadedSelector } from 'invision-core/src/components/metadata/codes/codes.selectors';
import { CODES } from 'invision-core/src/components/metadata/codes/codes.constants';
import CoreLocaleKeys from 'invision-core/src/locales/core.locale.keys';
import CustomerLocaleKeys from '../../../locales/keys';
import { IsFetchingOfferingsSelector, SearchSubscriberOfferingsWithFormattedServiceIdentifierSelector, SelectedSubscriberOfferingInstanceIdSelector, SubsriberOfferingsFilterDataSelector, SubsriberOfferingsPaginationDataSelector } from '../../../reducers/selectors/search.subscriber.offerings.selectors';
import { searchSubscriberOfferings, setOfferingFilterData, setOfferingPaginationData } from '../../../reducers/actions/offering.order.actions';
import { setSelectedOfferingInstanceId } from '../../../reducers/actions/customer.actions';
import { DEFAULT_MAXIMUM_SLOTS, DEFAULT_PAGE_NUMBER, offeringSearchByFilters, offeringStatusFilters, OFFERING_STATUS_TYPES, SEARCH_BY_TYPES } from './offerings.constants';
import { DASHBOARD_ROUTE } from '../../../reducers/constants/dashboard.constants';
var OfferingsController = /*#__PURE__*/function () {
  function OfferingsController($ngRedux, $state, uiNotificationService) {
    _classCallCheck(this, OfferingsController);
    Object.assign(this, {
      $ngRedux: $ngRedux,
      $state: $state,
      CustomerLocaleKeys: CustomerLocaleKeys,
      CoreLocaleKeys: CoreLocaleKeys,
      DEFAULT_MAXIMUM_SLOTS: DEFAULT_MAXIMUM_SLOTS,
      DEFAULT_PAGE_NUMBER: DEFAULT_PAGE_NUMBER,
      goBack: this.goBack.bind(this),
      offerStatusFilters: offeringStatusFilters(),
      onFilterOptionSelected: this.onFilterOptionSelected.bind(this),
      onOfferingSelected: this.onOfferingSelected.bind(this),
      onPageSelected: this.onPageSelected.bind(this),
      onPageSizeOptionSelected: this.onPageSizeOptionSelected.bind(this),
      onSearchByOptionSelected: this.onSearchByOptionSelected.bind(this),
      onSearchSubmitted: this.onSearchSubmitted.bind(this),
      uiNotificationService: uiNotificationService
    });
  }
  return _createClass(OfferingsController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      var controllerActions = {
        fetchCodeTypes: fetchCodeTypes,
        searchSubscriberOfferings: searchSubscriberOfferings,
        setOfferingFilterData: setOfferingFilterData,
        setOfferingPaginationData: setOfferingPaginationData,
        setSelectedOfferingInstanceId: setSelectedOfferingInstanceId,
        stateGo: stateGo
      };
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          codeTypeLoaded: MetadataCodeLoadedSelector(__, store),
          filterData: SubsriberOfferingsFilterDataSelector(store),
          isFetchingOfferings: IsFetchingOfferingsSelector(store),
          lastRoute: LastRouteSelector(store),
          offerings: SearchSubscriberOfferingsWithFormattedServiceIdentifierSelector(store),
          paginationData: SubsriberOfferingsPaginationDataSelector(store),
          routeParams: RouteParams(store),
          routeState: RouteCurrentStateSelector(store),
          selectedOfferingInstanceId: SelectedSubscriberOfferingInstanceIdSelector(store)
        };
      };
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
      var codeTables = [CODES.ServiceAttribute, CODES.RegularExpression, CODES.ServiceLifeCycleStatus];
      codeTables.forEach(function (codeType) {
        if (!_this.state.codeTypeLoaded(codeType)) {
          _this.actions.fetchCodeTypes(codeType).catch(function (error) {
            _this.uiNotificationService.transientError(error.translatedMessage);
          });
        }
      });
      this.optionalParams = {
        customerId: this.state.currentCustomerId,
        offeringInstanceId: this.state.routeParams.offeringInstanceId
      };
      this.actions.setSelectedOfferingInstanceId(null);
      if (this.state.routeParams.offeringInstanceId) {
        var offeringStatusTypes = Object.values(OFFERING_STATUS_TYPES);
        this.setSelectedOfferStatus(offeringStatusTypes.map(function (status) {
          return {
            id: status
          };
        }));
        this.actions.setOfferingFilterData(SEARCH_BY_TYPES.OFFERING_INSTANCE_ID, this.state.routeParams.offeringInstanceId, offeringStatusTypes);
        this.searchByFilters = offeringSearchByFilters(SEARCH_BY_TYPES.OFFERING_INSTANCE_ID);
      } else {
        this.actions.setOfferingFilterData(SEARCH_BY_TYPES.OFFERING_NAME, null, [OFFERING_STATUS_TYPES.ACTIVE]);
        this.searchByFilters = offeringSearchByFilters(SEARCH_BY_TYPES.OFFERING_NAME);
      }
      this.fetchOfferings();
    }
  }, {
    key: "fetchOfferings",
    value: function fetchOfferings() {
      var _this2 = this;
      var params = Object.assign({}, this.state.routeParams, {
        pageNumber: this.state.paginationData.pageNumber,
        pageSize: this.state.paginationData.pageSize,
        status: this.state.filterData.filterBy
      });
      if (this.state.filterData.searchTerm) {
        if (this.state.filterData.searchBy === SEARCH_BY_TYPES.OFFERING_INSTANCE_ID) {
          params.offeringInstanceIds = [this.state.filterData.searchTerm];
        } else {
          params.offerName = this.state.filterData.searchTerm;
        }
      }
      this.actions.searchSubscriberOfferings(params).then(function () {
        if (_this2.state.offerings.length) {
          _this2.actions.setSelectedOfferingInstanceId(_this2.state.offerings[0].offerDetails.OfferingInstanceId);
        }
      }).catch(function (error) {
        _this2.uiNotificationService.transientError(error.translatedMessage);
      });
    }
  }, {
    key: "onSearchByOptionSelected",
    value: function onSearchByOptionSelected(searchBy) {
      this.actions.setOfferingFilterData(searchBy.id, this.state.filterData.searchTerm, this.state.filterData.filterBy);
      this.actions.setOfferingPaginationData(DEFAULT_PAGE_NUMBER, this.state.paginationData.pageSize);
    }
  }, {
    key: "onSearchSubmitted",
    value: function onSearchSubmitted(searchTerm) {
      this.actions.setOfferingFilterData(this.state.filterData.searchBy, searchTerm, this.state.filterData.filterBy);
      this.actions.setOfferingPaginationData(DEFAULT_PAGE_NUMBER, this.state.paginationData.pageSize);
      this.fetchOfferings();
    }
  }, {
    key: "onFilterOptionSelected",
    value: function onFilterOptionSelected() {
      var filterBy = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      this.setSelectedOfferStatus(filterBy);
      this.actions.setOfferingFilterData(this.state.filterData.searchBy, this.state.filterData.searchTerm, filterBy.map(function (filter) {
        return filter.id;
      }));
      this.actions.setOfferingPaginationData(DEFAULT_PAGE_NUMBER, this.state.paginationData.pageSize);
      this.fetchOfferings();
    }
  }, {
    key: "onPageSizeOptionSelected",
    value: function onPageSizeOptionSelected(pageSize) {
      this.actions.setOfferingPaginationData(DEFAULT_PAGE_NUMBER, pageSize);
      this.fetchOfferings();
    }
  }, {
    key: "onPageSelected",
    value: function onPageSelected(pageNumber) {
      this.actions.setOfferingPaginationData(pageNumber, this.state.paginationData.pageSize);
      this.fetchOfferings();
    }
  }, {
    key: "setSelectedOfferStatus",
    value: function setSelectedOfferStatus() {
      var selectedOfferStatus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      this.offerStatusFilters = this.offerStatusFilters.map(function (item) {
        return Object.assign(item, {
          selected: selectedOfferStatus.some(function (filter) {
            return filter.id === item.id;
          })
        });
      });
    }
  }, {
    key: "onOfferingSelected",
    value: function onOfferingSelected(offeringInstanceId) {
      this.actions.setSelectedOfferingInstanceId(offeringInstanceId);
    }
  }, {
    key: "goBack",
    value: function goBack() {
      var route = this.state.lastRoute.name || DASHBOARD_ROUTE;
      var params = this.state.lastRoute.params || {};
      this.$state.go(route, params);
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.disconnectRedux();
    }
  }]);
}();
export default {
  controller: OfferingsController,
  template: require('./offerings.template.html')
};